import { colors } from 'styles/colors';
import { EChartsOption } from 'echarts';
import { defaultYAxisConfig } from '../constants';
import { YAXisOption } from 'echarts/types/dist/shared';
import { HealthVariant } from './components/UnitsInfo/types';
import { t } from 'i18next';
import { GetUnitHealthHistory } from '../types';

export function generateXAxisNames(data: GetUnitHealthHistory): { value: string }[] {
  const axis: { value: string }[] = [];

  for (const item of (data.MONTHLY_HISTORY ?? [])) {
    const date = new Date(item.YEAR, item.MONTH - 1, 1);
    axis.push({
      value: date.toISOString(),
    });
  }

  return axis;
}

export function createHealthYAxis(): EChartsOption['yAxis'] {
  return {
    ...defaultYAxisConfig,
    axisLabel: {
      ...defaultYAxisConfig.axisLabel,
      formatter: (value) => `${value}%`,
    },
    splitNumber: 5,
    min: 0,
    interval: 25,
    max: 100,
  } as YAXisOption;
}

export function colorByHealthVariant(variant: HealthVariant): string {
  switch (variant) {
    case 'healthy': return colors.state.success.base;
    case 'alert': return colors.state.warning.base;
    case 'critical': return colors.state.danger.base;
    default: return colors.icon['soft-400'];
  }
}

export function hoverColorByHealthVariant(variant: HealthVariant): string {
  switch (variant) {
    case 'healthy': return colors.state.success.dark;
    case 'alert': return colors.state.warning.dark;
    case 'critical': return colors.state.danger.dark;
    default: return colors.icon['strong-800'];
  }
}

export function parseHealthVariantLabel(variant: HealthVariant): string {
  switch (variant) {
    case 'alert': return t('emAlertaSemiCritico');
    case 'critical': return t('critica');
    case 'healthy': return t('saudavel');
    default: return t('offline');
  }
}
